import * as Bootstrap from 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';



window.bootstrap = Bootstrap;

const ENVIRONMENT = 'developer'; // Verifica che non possa essere modificato, riattivando così tutti i log

window.AJAX_DONE = 4;
window.AJAX_OK = 200;

const MSG_TRACE = 1;
const MSG_INFO = 2;
const MSG_WARNING = 3;
const MSG_ERROR = 4;

window.L_D = 1;
window.L_I = 2;
window.L_W = 3;
window.L_E = 4;

document.addEventListener('DOMContentLoaded', function(){
    
    const msgCollection = document.querySelector('[data-msg-collection]').dataset.msgCollection;
    if (msgCollection) {
        window.setMessagePosition('messages-block');
        window.showMessage(JSON.parse(msgCollection));
    }

    setEventAttachmentDelete(); // Attachments are in all entity

    setBurgerMenu();
});

window.isEnvironmentDev = function()
{
    return 'developer' == ENVIRONMENT ? true : false;
}

window.setBurgerMenu = function ()
{
    // Sidebar menù
    const mainWrapper = document.getElementById('main-wrapper');
    const headerCollapse = document.getElementById('headerCollapse');
    headerCollapse.addEventListener('click', function() {
        if (mainWrapper.classList.contains('show-sidebar')) {
            mainWrapper.classList.remove('show-sidebar');
        } else {
            mainWrapper.classList.add('show-sidebar');
        }
    });
    const sidebarCollapse = document.getElementById('sidebarCollapse');
    sidebarCollapse.addEventListener('click', function() {
        mainWrapper.classList.remove('show-sidebar');
    });
}

window.makeAjaxRequest = function (nodeWithCallInfo, callFunctionForPositiveStatus)
{
    const url = nodeWithCallInfo.dataset.url;
    const httpRequest = new XMLHttpRequest();
    httpRequest.open("GET", url);
    httpRequest.send();
    httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === window.AJAX_DONE) {
          if (httpRequest.status === window.AJAX_OK) {
            window.setLog('makeAjaxRequest()');
            setBurgerMenu();
            switch (callFunctionForPositiveStatus) {
                case 'showActivityForm':
                    window.showActivityForm(httpRequest.responseText);
                    break;
                case 'setIncomingOutGoChart':
                    window.setIncomingOutGoChart(JSON.parse(httpRequest.responseText));
                    break;
                case 'showMessage':
                    window.showMessage(JSON.parse(httpRequest.responseText));
                    break;
                case 'showSearchTable':
                    window.showSearchTable(httpRequest.responseText);
                    break;
            }
          } else {
            window.setLog('Error for "'+callFunctionForPositiveStatus+'" (' + httpRequest.status + ')', window.LOG_ERROR);
            return false;
          }
        }
    }
   
}

/*
 * Get a MyMsgCollection istance as input and show as alert messages
 */
window.showMessage = function(input)
{
    let output = '';
    if(input) {
        for (let i = 0; i < input.length; i++) {
            let type = '';
            switch (input[i].level) {
                case MSG_TRACE:
                    type = 'light';
                    break;
                case MSG_INFO:
                    type = 'info';
                    break;
                case MSG_WARNING:
                    type = 'warning';
                    break;
                case MSG_ERROR:
                    type = 'danger';
                    break;
            }
            output += '<div class="alert alert-'+type+'" role="alert">'+input[i].message+'</div>';
        }
        
        // Shopw all message. Then, delete then
        const positionId = window.getMessagePosition();
        let position = document.getElementById(positionId);
        if (!position) {
            position = document.getElementById('messages-block'); // Set a default
        }
        if (position) {
            position.innerHTML = output; 
            scroll(0,0);
            const timer = input.length > 1 ? input.length * 2000 : 3000;
            setTimeout(function(){
               const alertList = document.querySelectorAll('.alert');
               alertList.forEach(function(alertNode){
                   const alert = new window.bootstrap.Alert(alertNode);
                   alert.close();
               });
            }, timer);
        } else {
            throw new Error('Messages block not found');
        }
    }
}

window.setMessagePosition = function(position)
{
    window.messagePosition = position;
}

window.getMessagePosition = function()
{
    return window.messagePosition;
}

window.hideElement = function(node, myClass = 'd-block')
{
    const deleteCLass = 'd-none';
    if (node.classList.contains(myClass)) {
        node.classList.remove(myClass);
    }
    if (!node.classList.contains(deleteCLass)) {
        node.classList.add(deleteCLass);
    }
}

window.showElement = function(node, myClass = 'd-none')
{
    const deleteCLass = 'd-block';
    if (node.classList.contains(myClass)) {
        node.classList.remove(myClass);
    }
    if (!node.classList.contains(deleteCLass)) {
        node.classList.add(deleteCLass);
    }
}

/*
 * Mi tengo i log sempre attivi, ma li potrò disattivare tutti in blocco se necessario
 */
window.setLog = function(message, level) 
{
    if (window.isEnvironmentDev()) {
        switch (level) {
            case window.L_D:
                console.debug(message);
                break;
            case window.L_I:
                console.log(message);
                break;
            case window.L_W:
                console.warn(message);
                break;
            case window.L_E:
                console.error()(message);
                break;
            default:
                console.log(message);
        }
    }
}

window.setCookie = function(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/*
* Delete attachment (ajax call)
*/
window.setEventAttachmentDelete = function ()
{
    const attachmentDeleteIdList = document.querySelectorAll('[data-attachment-to-delete]');
    attachmentDeleteIdList.forEach(function(attachmentDeleteId){
        attachmentDeleteId.addEventListener('click', function(e) {
            e.preventDefault();
            if (confirm('Cancellare ?')) {
                window.makeAjaxRequest(e.currentTarget, 'showMessage');
                const attachmentRowList = document.querySelectorAll('[data-attachment-id="'+e.currentTarget.dataset.attachmentToDelete+'"]');
                attachmentRowList.forEach(function(attachmentRow) {
                    window.hideElement(attachmentRow);
                });
            }
        });
    });
}